"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BannerInputWrap = exports.RequestBanner = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const Banner = styled_components_1.default.section `
  background: ${(p) => p.$tone === "primary"
    ? `linear-gradient(135deg, ${theme_1.theme.colors.lightBlue} 0%, ${theme_1.theme.colors.darkBlue} 100%)`
    : `linear-gradient(135deg, ${theme_1.theme.colors.green} 0%, ${theme_1.theme.colors.darkestGreen} 100%)`};
  border-radius: 4px;
  padding: ${theme_1.theme.spacing(4)} ${theme_1.theme.spacing(4)};
  margin-bottom: ${theme_1.theme.spacing(4)};
  color: ${theme_1.theme.colors.white};
`;
const Eyebrow = styled_components_1.default.p `
  margin: 0;
  ${theme_1.theme.fontLabelBold};
  ${theme_1.theme.fontSize(-1)};
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
`;
const Headline = styled_components_1.default.h3 `
  margin: 6px 0;
  ${theme_1.theme.fontTitle};
  ${theme_1.theme.fontSize(1)};
  letter-spacing: -0.01em;
  line-height: 1.15;
  color: ${theme_1.theme.colors.white};

  span {
    color: ${theme_1.theme.colors.lightGreen};
  }
`;
const Body = styled_components_1.default.p `
  margin: 0 0 ${theme_1.theme.spacing(3)};
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: rgba(255, 255, 255, 0.82);
  line-height: 1.6;
  max-width: 520px;
`;
const Row = styled_components_1.default.div `
  display: flex;
  gap: ${theme_1.theme.spacing(2)};
  flex-wrap: wrap;
`;
const InputWrap = styled_components_1.default.div `
  flex: 1 1 190px;
  min-width: 0;

  input {
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.12);
    padding: ${theme_1.theme.spacing(2)} ${theme_1.theme.spacing(2)};
    color: ${theme_1.theme.colors.white};
    ${theme_1.theme.fontNormal};
    font-size: 16px; /* keeps iOS from zooming the page on focus */
    outline: 0;
  }

  input::placeholder {
    color: rgba(255, 255, 255, 0.65);
  }

  input:focus {
    border-color: ${theme_1.theme.colors.white};
    background: rgba(255, 255, 255, 0.2);
  }
`;
exports.BannerInputWrap = InputWrap;
const SendButton = styled_components_1.default.button `
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  flex: 0 0 auto;
  border: 0;
  border-radius: 4px;
  background: ${(p) => p.$tone === "primary" ? theme_1.theme.colors.green : theme_1.theme.colors.white};
  color: ${(p) => p.$tone === "primary" ? theme_1.theme.colors.darkestGreen : theme_1.theme.colors.darkGreen};
  ${theme_1.theme.fontLabelBold};
  font-size: 16px;
  padding: ${theme_1.theme.spacing(2)} ${theme_1.theme.spacing(3)};
  cursor: pointer;

  &:hover {
    background: ${(p) => p.$tone === "primary" ? theme_1.theme.colors.lightGreen : theme_1.theme.colors.grey(5)};
  }

  &:focus-visible {
    outline: 2px solid ${theme_1.theme.colors.white};
    outline-offset: 2px;
  }
`;
const Note = styled_components_1.default.p `
  margin: ${theme_1.theme.spacing(2)} 0 0;
  ${theme_1.theme.fontNormal};
  ${theme_1.theme.fontSize(0)};
  color: ${(p) => (p.$warn ? "#FFD9A8" : "rgba(255, 255, 255, 0.75)")};
`;
/** Shared shell for the request-a-price banners. */
const RequestBanner = ({ tone = "primary", eyebrow, headline, body, buttonLabel, submitState = "idle", contact, note, defaultNote, sectionRef, emailRef, extraField, onSend, }) => ((0, jsx_runtime_1.jsxs)(Banner, { ref: sectionRef, "$tone": tone, children: [(0, jsx_runtime_1.jsx)(Eyebrow, { children: eyebrow }), (0, jsx_runtime_1.jsx)(Headline, { children: headline }), (0, jsx_runtime_1.jsx)(Body, { children: body }), (0, jsx_runtime_1.jsxs)(Row, { children: [(0, jsx_runtime_1.jsx)(InputWrap, { children: (0, jsx_runtime_1.jsx)("input", { ref: emailRef, type: "email", inputMode: "email", autoComplete: "email", placeholder: "Email", "aria-label": "Email", value: contact.email, onChange: (e) => contact.onEmailChange(e.target.value) }) }), (0, jsx_runtime_1.jsx)(InputWrap, { children: (0, jsx_runtime_1.jsx)("input", { type: "tel", inputMode: "tel", autoComplete: "tel", placeholder: "Phone (optional)", "aria-label": "Phone", value: contact.phone, onChange: (e) => contact.onPhoneChange(e.target.value) }) }), extraField, (0, jsx_runtime_1.jsx)(SendButton, { type: "button", "$tone": tone, disabled: submitState === "sending" || submitState === "sent", onClick: onSend, children: submitState === "sending"
                        ? "Sending…"
                        : submitState === "sent"
                            ? "Sent"
                            : buttonLabel })] }), (0, jsx_runtime_1.jsx)(Note, { "$warn": note.warn, "aria-live": "polite", children: note.text || defaultNote })] }));
exports.RequestBanner = RequestBanner;
